import isEmpty from 'lodash/isEmpty';
import { FAQ } from '../../types/content';
import { JobSearchLandingPage } from '../../types/landing';
import { RelatedSearchLandingPage } from '../../types/search';
import { transformOrganisation } from './content';

export const transformJobSearchLandingPage = (data: any): JobSearchLandingPage => {
  const org = data.relationships?.field_organisation;
  return {
    id: data.drupal_id || data.id,
    title: data.title,
    path: data.path?.alias,
    breadcrumbLabel: data.field_breadcrumb_label,
    relatedSearchLandingPages: data?.field_related_job_search_pages
      ? data?.field_related_job_search_pages?.map((item: any) => {
          return { path: item.uri, title: item.title } as RelatedSearchLandingPage;
        })
      : [],
    meta: data.metatag ?? [],
    opportunityType:
      !isEmpty(data.relationships?.field_opportunity_type) && data.relationships?.field_opportunity_type
        ? data.relationships?.field_opportunity_type?.map((opportunityType: any) => opportunityType.label)
        : [],
    sectors: data.relationships?.field_sectors
      ? data.relationships?.field_sectors?.map((sector: any) => sector.label)
      : [],
    faqs:
      data.relationships?.field_faqs.map((faq: any) => {
        return { question: faq.field_question?.processed, answer: faq.field_answer?.processed } as FAQ;
      }) || [],
    organisation: org && transformOrganisation({}, org),
    city: data.relationships?.field_city[0]?.label
  };
};
